import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerText from '../../../components/custom_components/Text'
import { useDashboardStore } from '../DashboardStore'
import InfoTooltipButton from './InfoTooltipButton'

const DashboardFiltersAreaHeader: FC = () => {
  const { t } = useTranslation()
  const distributionBubobumCounters = useDashboardStore((state) => state.distributionBubobumCounters)

  const infoTooltip = useMemo(() => {
    const noOffice = distributionBubobumCounters === null || distributionBubobumCounters.branchOffice === 0
    return t(
      noOffice
        ? 'dashboard.companyManager.filtersArea.header.infoTooltipNoOffice'
        : 'dashboard.companyManager.filtersArea.header.infoTooltip',
    )
  }, [distributionBubobumCounters, t])

  return (
    <PerFlexRow justify="space-between" align="middle" className="dashboard-filters-area__header">
      <PerFlexRow justify="space-between" align="top" noWrap width="fullWidth">
        <PerText fontWeight="bold" fontSize="m">
          {t('dashboard.companyManager.filtersArea.header.title')}
        </PerText>
        <InfoTooltipButton title={infoTooltip} />
      </PerFlexRow>
    </PerFlexRow>
  )
}

export default DashboardFiltersAreaHeader
